/**
 * Supabase Client Configuration
 * Initializes and exports the Supabase client for database and auth operations
 */

import { createClient } from '@supabase/supabase-js';

// Get environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Only create client if credentials are available
let supabase = null;

if (supabaseUrl && supabaseAnonKey) {
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionUrl: true
    }
  });
}

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not found. Some features like likes and ratings may not work correctly.');
}

// Export Supabase client (may be null)
export { supabase };
export default supabase;
